var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Transition", { attrs: { name: "slide-y-reverse-transition" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.show,
            expression: "show",
          },
          {
            name: "shortkey",
            rawName: "v-shortkey",
            value: { meta: ["meta", "k"], ctrl: ["ctrl", "k"] },
            expression: "{ meta: ['meta', 'k'], ctrl: ['ctrl', 'k'] }",
          },
        ],
        staticClass: "portal-component",
        on: {
          shortkey: _vm.handleHotkey,
          keydown: [
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
              ) {
                return null
              }
              $event.stopPropagation()
              return _vm.handleArrowUp.apply(null, arguments)
            },
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "down", 40, $event.key, [
                  "Down",
                  "ArrowDown",
                ])
              ) {
                return null
              }
              $event.stopPropagation()
              return _vm.handleArrowDown.apply(null, arguments)
            },
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              $event.stopPropagation()
              return _vm.handleEnter.apply(null, arguments)
            },
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
              ) {
                return null
              }
              _vm.show = false
            },
          ],
          click: function ($event) {
            _vm.show = false
          },
        },
      },
      [
        _c(
          "div",
          { staticClass: "dropdown-container" },
          [
            _c(
              "Transition",
              { attrs: { name: "slide-y-reverse-transition" } },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.show,
                        expression: "show",
                      },
                    ],
                    staticClass: "dropdown",
                  },
                  [
                    _c("VTextField", {
                      ref: "textfield",
                      staticClass: "portal-input mb-2",
                      attrs: { placeholder: "Jump to …", hideDetails: "" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                      model: {
                        value: _vm.input,
                        callback: function ($$v) {
                          _vm.input = $$v
                        },
                        expression: "input",
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "actions-container" }, [
                      _c(
                        "div",
                        { staticClass: "actions", attrs: { tabindex: "0" } },
                        [
                          _c(
                            "TransitionGroup",
                            { attrs: { name: "list-complete", tag: "div" } },
                            [
                              !_vm.filteredActions.length
                                ? _c(
                                    "div",
                                    {
                                      key: "$$$instructions",
                                      staticClass: "instructions",
                                    },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          "\n                    Quickly jump to another page, app or bucket by searching for it.\n                  "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                    Start with\n                    "
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "code",
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.prefill("doc")
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                      doc\n                    "
                                            ),
                                          ]
                                        ),
                                        _vm._v(
                                          "\n                    or\n                    "
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "code",
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.prefill("?")
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                      ?\n                    "
                                            ),
                                          ]
                                        ),
                                        _vm._v(
                                          "\n                    to search for documentation.\n                  "
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._l(
                                    _vm.filteredActions,
                                    function (action, index) {
                                      return _c(
                                        "VCard",
                                        {
                                          key: action.getKey(),
                                          ref: "action" + index,
                                          refInFor: true,
                                          staticClass:
                                            "action px-3 py-2 contrast mb-2 list-complete-item",
                                          class: {
                                            focused: _vm.focusIndex === index,
                                          },
                                          attrs: { tabindex: "-1" },
                                          nativeOn: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return action.trigger()
                                            },
                                          },
                                        },
                                        [
                                          action.getIcon() !== undefined
                                            ? _c("KmIcon", {
                                                staticClass:
                                                  "category-icon pr-2",
                                                attrs: {
                                                  name: action.getIcon(),
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "h1",
                                            {
                                              staticClass:
                                                "font-light subheading",
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(action.getName()) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("VSpacer"),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(action.getCategory())
                                            ),
                                          ]),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }